module.exports = {"title":"Deliverables","body":"<p>This page contains various deliverables required for the Senior project. Find them with the links on the left.</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./deliverables/index.md
 ** module id = 469
 ** module chunks = 0
 **/